import { gql } from '@apollo/client';

// Deliberately independent of audit filters, global stats and personal data.
export const CPM_REPORT_CAMPAIGN = gql`
  query CpmReportCampaign($id: ID!) {
    adminCpmCampaign(id: $id) {
      id name status start_date end_date currency cpm_rate_cents
      cpm_platform_rates { platform cpm_rate_cents } allowed_platforms
      budget_total_cents budget_spent_cents budget_stored_spent_cents budget_retained_cents
      budget_remaining_cents budget_spend_drift_cents min_views_threshold
      max_payout_per_clip_cents max_payout_per_clipper_cents
      view_accrual_window_hours submissions_count createdAt updatedAt
    }
  }
`;

export const CPM_REPORT_SUBMISSIONS = gql`
  query CpmReportSubmissions($campaignId: ID!, $limit: Int!, $offset: Int!) {
    adminCpmCampaignSubmissions(campaignId: $campaignId, limit: $limit, offset: $offset) {
      data {
        id platform url canonical_url admin_approval disqualified
        last_counted_views accumulated_payout_cents cpm_rate_override_cents
        last_view_sync_at createdAt user_id suspected_duplicate
        accrual_window_ends_at final_accrual_views final_accrual_captured_at
        daily_views { date views }
      }
      total pageCount
    }
  }
`;

// The budget burndown's daily spend: aggregate cents per day, no rows or people.
export const CPM_REPORT_SPEND = gql`
  query CpmReportSpend($campaignId: ID!) {
    adminCpmCampaignSubmissions(campaignId: $campaignId, limit: 1, offset: 0) {
      stats { total_earnings_cents daily_spend { date spend_cents } }
    }
  }
`;

// Server re-collects authorized aggregates and verifies the browser fingerprint.
export const CPM_REPORT_CONCLUSIONS = gql`
  mutation CpmReportConclusions($campaignId: ID!, $reportAsOf: String!, $expectedFactsFingerprint: String!) {
    adminGenerateCpmCampaignReportConclusions(campaignId: $campaignId, reportAsOf: $reportAsOf, expectedFactsFingerprint: $expectedFactsFingerprint) {
      fingerprint generatedAt summary
      highlights { title text evidenceKeys }
      recommendations { title text evidenceKeys }
    }
  }
`;
